
























import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component({
  components: {}
})
export default class InvestmentHeaderWithLogo extends Vue {

  @Prop({required: true})
  title: string;

  @Prop({required: true})
  showLogo: boolean;


  @Prop({required: true})
  showTitle: boolean;
}
